 <template>
    <div class="container">
        <div class="content">
            <img class="tip_icon" src="../assets/img/box_titlepic.png" alt="">
            <div v-if="lotteryDetail.user_have_credit" class="currentCredit">
                <span>{{'当前积分：'+lotteryDetail.user_have_credit}}</span>
                <p v-if="lotteryDetail.credit_desc!=''">{{lotteryDetail.credit_desc}}</p>
            </div>
            <div id="boxArea">
                <div class="boxWrap" @click="clickBox"></div>
                <div class="boxArea-tip">
                    输入正确的密码即可开启宝箱，
                    <span>{{lotteryDetail.draw_count_desc}}</span>！
                    <span v-if="lotteryDetail.detail_url">点击<a href="javascript:void(0);" @click="cluePage">【查看活动详情】</a>寻找线索！</span>
                </div>
            </div>
            <div class="award_btn">
                <p @click="clickAward">我的中奖记录</p>
            </div>
        </div>
        <section class="tip_text_container" v-if="lotteryDetail.show_desc=='1'"><!-- 奖品说明 -->
                <div class="tip_award">
                    <p>奖项说明</p>
                </div>
                <div class="awardList">
                    <ul class="lists">
                        <li class="list" v-for="(item,index) in prizeListData" :key="index">
                            <p class="awardPic" v-if="prizeListImgDisplay">
                                <img :src="item.image" alt="">
                            </p>
                            <p :class="prizeListImgDisplay?'pName':'pName_sec'">{{item.name}}</p>
                            <p :class="prizeListImgDisplay?'pDesc':'pDesc_sec'">{{item.desc}}</p>
                            <p :class="prizeListImgDisplay?'pSur':'pSur_sec'" v-if="lotteryDetail.show_prize_num=='1'">{{'剩余数量：'+item.prize_number}}</p>
                        </li>
                    </ul>
                </div>
        </section>
        <section class="tip_text_container"><!-- 活动说明 -->
                <div class="tip_award">
                        <p>活动说明</p>
                </div>
                <div class="awardList">
                  <div class="lists" v-if="lotteryDetail.about_lottery">
                      <p class="explain">
                        <pre>{{lotteryDetail.about_lottery}}</pre>
                      </p>
                  </div>
                  <div class="lists" v-else>
                      <p class="explain" v-html="lotteryDetail.desc"></p>
                  </div>
                </div>
        </section>
        <section class="foot">
            <div class="logo">
                <img :src="logo_img" alt="">
            </div>
        </section>
        <!-- 密码弹出层 -->
        <div id="boxMask" v-if="boxMaskDisplay" @touchmove.prevent>
            <div class="boxMask_closeBtn" @click="boxMaskDisplay = false">X</div>
            <div class="boxMask_codeArea">
                <slide ref="slide"></slide>
                <slide></slide>
                <slide></slide>
                <slide></slide>
            </div>
            <div class="boxMask_submitBtn lottery-draw" @click="submitCode">提交密码</div>
        </div>
        <!-- 实物中奖弹窗 -->
        <formDialog
            :formDialogDisplay.sync="formDialogDisplay"
            :title="prizeReqData.msg"
            :id="prizeReqData.prize_receive_record_id"
            :formList="fillInfo"></formDialog>
        <div class="lostTip" v-if="lostTipDisplay">
            <div class="lostTip_content">
                <i class="el-icon-error" @click="lostTipDisplay = false"></i>
                <div class="lostTip_content_text">
                    {{lostTipMsg}}
                </div>
                <div class="lostTip_btn" @click="lostTipDisplay = false">确 定</div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import FormDialog from 'components/formDialog/formDialog'
import Slide from './slide'

import sqBg from '../assets/images/lamp.png'
import sqBgGif from '../assets/images/lamp_active.gif'

import {logo_img} from '../config/config';
    export default {
        data() {
            return {
                logo_img, // logo图片地址
                boxMaskDisplay: false,
                code: '',
                formLabelWidth: '30%',
                dialogShow: false,
                dialogItemsState: { // 中奖表单的选项的状态
                    name: false,
                    tel: false,
                    idcard: false,
                    add: false
                },
                formDialogDisplay: false,
                lostTipDisplay: false,
                formSureFlag: true, // 中奖表单提交锁
                fillInfo: {},    // 中奖表单填写内容
                fields: {},     // 中奖表单提交请求的参数
                prizeReqData: {}    // 接收请求成功的数据
            }
        },
        props:['lotteryDetail','prizeListData', 'prizeListImgDisplay', 'preview', 'platRight', 'coordinate'],
        methods: {
          platRightCheck() {
            if (this.platRight && this.platRight.right === 0) {
              if (this.platRight.apptype === 'WX') {
                this.$router.push('/wxScan')
              } else {
                this.$dialog({
                  message: this.platRight.name,
                  url: this.platRight.url,
                  key: this.platRight.apptype
                })
              }
              return true
            }
          },
          clickBox() {
            // 端检查
            if (this.platRightCheck()) return
            this.boxMaskDisplay = true
          },
          cluePage() {
            // 端检查
            if (this.platRightCheck()) return
            window.location.href = this.lotteryDetail.detail_url
          },
            submitCode(){
                // this.getCode()
                this.boxMaskDisplay = false
                let vm = this
                let latitude, longitude
                if (this.coordinate) {
                  latitude = this.coordinate.latitude
                  longitude = this.coordinate.longitude
                }
                this.Get({
                    url: '/activity/api.php',
                    data: {
                        m: 'front',
                        subm: 'lottery',
                        action: 'drawprize',
                        lat: latitude || '',
                        lng: longitude || '',
                        preview: vm.preview,
                        box_code: vm.getCode()
                    },
                    success: function(data){
                        if(data.code == 3001){
                            vm.prizeReqData = data.data
                            // 处理中奖的情况
                            vm.drawResult(vm.prizeReqData)

                            // 我直接用请求中的credit和credittype吧
                            if(vm.prizeReqData.credit_type != 0 && vm.prizeReqData.credit != 0 && typeof(vm.lotteryDetail.user_have_credit) !== 'undefined'){
                                if(vm.prizeReqData.credit_type == 1){
                                    vm.lotteryDetail.user_have_credit -= vm.lotteryDetail.credit;
                                }else if(data.data.credit_type == 2){
                                    vm.lotteryDetail.user_have_credit += vm.lotteryDetail.credit;
                                }
                            }
                            // 更新prizelist奖品数量信息等
                            if(data.data.prize_id != 0) {
                                vm.prizeListUpdate()
                            }
                        }
                    },
                    error: function(data){
                        if(data.code==5007||data.code == 5110||data.code==5011||data.code==5013||data.code==5014||data.code==5020||data.code==5107) {
                            // vm.$router.replace('/');
                            // window.location.reload(true);
                        }
                        if(data.code == 5129) {
                            // 我直接用请求中的credit和credittype吧
                            if(data.data.credit_type != 0 && data.data.credit != 0 && typeof(vm.lotteryDetail.user_have_credit) !== 'undefined'){
                                if(data.data.credit_type == 1){
                                    vm.lotteryDetail.user_have_credit -= vm.lotteryDetail.credit;
                                }else if(data.data.credit_type == 2){
                                    vm.lotteryDetail.user_have_credit += vm.lotteryDetail.credit;
                                }
                            }
                        }
                        vm.alertPrize(data.msg)
                    }
                })
            },
            prizeListUpdate() {
                this.$emit('prizeListUpdateNotice')
            },
            drawResult(data){
                // prize_id不为0时中奖
                if(data.prize_id){
                    if(data.prize_type == 1 && data.receive_msg.length){
                        this.fields = {
                            m: 'front',
                            subm: 'lottery',
                            action: 'receivemsg',
                            id: data.prize_receive_record_id
                        }
                        for(let i=0;i<data.receive_msg.length;i++){
                            let item = data.receive_msg[i]
                            this.fillInfo[item] = ''
                        }
                        // 打开中奖表单弹窗
                        this.formDialogDisplay = true;
                    }else{
                        this.resultTip(data)
                    }
                }else{
                    this.resultTip(data)
                }
            },

            lostTip(msg){
                this.lostTipDisplay = true
                this.lostTipMsg = msg
            },
            resultTip(data){
                if(data.prize_type === 3) {
                  this.alertPrize(data.msg, '立即领取', data.prize_url)
                } else {
                  this.alertPrize(data.msg)
                }
            },
            alertPrize(){//中奖后的弹框
              this.$emit.apply(this,[].concat.apply(['alertPrize'], arguments));
            },
            getCode(){
                let obj = this.$refs.slide.mySwiper
                let code = ''
                for(let i=0;i<obj.length;i++){
                    code += obj[i].realIndex == 9 ? 0 : obj[i].realIndex + 1
                }
                return code
            },
            clickAward() {
              // 端检查
              if (this.platRightCheck()) return
              this.$emit('clickAward')
            },
            getRandom(min, max) {
                let range = max - min
                return min + Math.round(Math.random() * range)
            }
        },
        components: {
            Slide,
            FormDialog
        }
    }
</script>

<style scoped lang="stylus">
    .lostTip{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.5);
        z-index: 999;
        .lostTip_content{
            position: relative;
            width: 80%;
            // min-height: 10%;
            padding: 10% 0 5%;
            background-color: #fff;
            margin: 50% auto 0;
            .lostTip_content_text{
                width: 90%;
                min-height: 40px;
                // background-color: #ccc;
                margin: auto;
                margin-bottom: 30px;
            }
            .lostTip_btn{
                width: 40%;
                height: 30px;
                line-height: 30px;
                background-color: orange;
                margin: auto;
                border-radius: 4px;
                color: #fff;
            }
            & > i{
                color: #e21843;
                position: absolute;
                top: 0;
                right: 0;
                transform: translateX(50%) translateY(-50%);
                background-color: #fff;
                border-radius: 50%;
            }
        }
    }
    #boxMask{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
    }
        .boxMask_codeArea{
            width: 90vw;
            height: 200px;
            margin: 150px auto 0;
            /* background: orange; */
            display: flex;
            justify-content: space-around;
        }
        .boxMask_closeBtn{
            position: absolute;
            top: 10px;
            right: 10px;
            width: 30px;
            height: 30px;
            background-color: red;
            border-radius: 50%;
            color: #fff;
            font-size: 20px;
            line-height: 30px;
        }
        .boxMask_submitBtn{
            width: 140px;
            height: 36px;
            line-height: 36px;
            border-radius: 6px;
            background-color: #ea4816;
            margin: 38px auto 0;
            color: #ffd618;
        }
    .content{
        background-image: url('../assets/images/title_bg.png');
        background-size: 100% 100%;
    }
        #boxArea
            min-height: 100px;
            display: flex;
            flex-direction: column;
            /* justify-content: ; */
            align-items: center;
            .boxWrap
                width: 60%
                height: 162px
                margin: 30px 0
                background: url('../assets/img/box.png') no-repeat
                background-size: contain
            .boxArea-tip{
                width: 80%;
                color: #dc5900;
                /* font-size: 14px; */
                text-align: left;
                a{
                    text-decoration: none
                }
            }
    .tip_icon{
        width: 60%;
        margin: 15px auto;
    }
    .currentCredit{
        margin-bottom: 10px;
        color: #444e45;
    }
    #squareBox{
        width: 96vw;
        height: 96vw;
        margin: 0 auto;
        background: orange;
        display: flex;
        justify-content: center;
        align-items: center;
        /* background: url(/static/image/lamp_active.gif); */
        background-size: 100% 100%;
    }

</style>



// WEBPACK FOOTER //
// src/components/boxPassword.vue